<script>
import SpeakerCard from './speaker-card.vue'
import SpeakerNavbar from './speaker-navbar.vue'
import PaginationButtons from '../pagination-buttons.vue'

export default {
  components: {SpeakerCard, SpeakerNavbar, PaginationButtons},
  props: ['eventShortName'],

  data() {
    return {
      filter: {},
      speakers: [],
      numSpeakers: 0,
      numPages: 0,
      numFavorites: 0,
      page: parseInt(this.$route.query.page) || 1,
    }
  },

  computed: {
    favoriteMode() { return this.eventShortName == undefined || !navigator.onLine }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.fetchSpeakers(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        if (this.filter.favorites)
          query.favorites = "1"
        if (this.filter.categories && this.filter.categories.length)
          query.categories = this.filter.categories
        if (this.filter.for_me)
          query.for_me = "1"
        this.pushQuery(query)
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchSpeakers({page: newValue, ...this.filter})
        // persist page in URL so browser-back restores it
        let query = {...this.$route.query}
        if (newValue > 1) query.page = newValue
        else delete query.page
        this.$router.replace({query}).catch(() => {})
      },
    },
  },

  created() {
    this.getFavorites()
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.$route.query.favorites) {
      this.filter.favorites = "1"
    } else if (this.favoriteMode) {
      this.filter.favorites = "1"
    }
    if (this.$route.query.categories) {
      const c = this.$route.query.categories
      this.$set(this.filter, 'categories', Array.isArray(c) ? c : [c])
    }
    if (this.$route.query.for_me) {
      this.$set(this.filter, 'for_me', 1)
    }
    this.fetchSpeakers({page: this.page, ...this.filter})
  },

  methods: {
    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    getFavorites() {
      let favorites = this.$storage.getItem('favorite_speaker', [])
      this.numFavorites = favorites.length
      return favorites
    },

    onSearchChanged: function (search) {
        if (search)
          this.$set(this.filter, 'search', search)
        else
          this.$delete(this.filter, 'search')
    },

    parseDate: function (datetimeStr, locale = 'de') {
      const opts = {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    toggleFavorites(onOff) {
      if (onOff) {
        this.$set(this.filter, 'favorites', "1")
      } else {
        this.$delete(this.filter, 'favorites')
      }

    },

    onCategories(ids) {
      this.$delete(this.filter, 'for_me')
      if (ids && ids.length) this.$set(this.filter, 'categories', ids)
      else this.$delete(this.filter, 'categories')
    },

    toggleForMe() {
      if (this.filter.for_me) {
        this.$delete(this.filter, 'for_me')
      } else {
        this.$delete(this.filter, 'categories')
        this.$set(this.filter, 'for_me', 1)
      }
    },

    fetchSpeakers: function (filter) {
      let me =  this
      let params = {...filter}
      let payload = {}
      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          this.speakers = []
          this.numSpeakers = 0
          this.numPages = 1
          return
        }
      } else {
        params.event_short_name = this.eventShortName
        if (params.favorites) {
          delete params.favorites
          payload.content_code = this.getFavorites()
        }
      }
      if (navigator.onLine) {
        if (this.favoriteMode || params.favorites === "1") {
          payload['content_code'] = this.getFavorites()
          delete params.favorites
        }
        this.$api.post('/speakers/', payload, {params: params,}).then(function(response){
          me.speakers = response.data.results
          me.numPages = response.data.pages
          me.numSpeakers = response.data.count
        })
      } else {
        me.speakers = Object.values(this.$storage.getItem('speakers', {}))
        me.numSpeakers = me.speakers.length
        me.numPages = 1
      }
    },

  },
}
</script>

<template>

  <div>
    <speaker-navbar class="mb-1"
      :filter="filter"
      fav-key="content_code"
      :fav-mode="favoriteMode"
      :event-short-name="eventShortName || ''"
      @search="onSearchChanged($event)"
      @delete-search="onSearchChanged($event)"
      @toggle-favorites="toggleFavorites($event)"
      @categories="onCategories($event)"
      @toggle-for-me="toggleForMe()"
    />

    <ol v-if="filter.for_me || (filter.categories && filter.categories.length)"
        class="breadcrumb bg-white ps-0 mt-1">
      <li v-if="filter.for_me" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none" @click.prevent="toggleForMe()">
          <b>Für mich&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="filter.categories && filter.categories.length" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none" @click.prevent="onCategories([])">
          <b>Kategorien ({{ filter.categories.length }})&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
    </ol>

    <div v-if="numSpeakers > 0">
      <small class="text-muted me-1">{{numFavorites}} Favoriten / {{numSpeakers}} Treffer</small>

      <div class="speaker-grid mt-1">
        <speaker-card v-for="speaker in speakers" :key="speaker.id" :speaker="speaker" 
         @favorite-changed="getFavorites" />
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />
    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>
/* Responsive card grid: as many ~11rem columns as fit (2 on mobile, more on
   md/lg/...). Cards fill their cell (see speaker-card width:100%). */
.speaker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: 1rem;
  align-items: stretch;
}
</style>